module.exports = __webpack_public_path__ + "img/sad-dog.7c9d15a1.png";